module.exports = "/_next/static/images/Build-28046483ec850930816b0b3a8fcd0279.webp";